import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { UserPlus, AlertOctagon } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("La contraseña debe tener al menos 6 caracteres."); return; }
    setBusy(true);
    const r = await register(name, email, password);
    setBusy(false);
    if (r.ok) nav("/dashboard");
    else setError(r.error);
  };

  return (
    <div className="min-h-[calc(100vh-60px)] flex items-center justify-center p-8">
      <form data-testid="register-form" onSubmit={submit} className="w-full max-w-md term-panel-strong p-8">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo.png" alt="Red Team Solutions" data-testid="register-logo" className="w-48" />
        </div>
        <div className="flex items-center gap-2 text-red-500 text-xs uppercase tracking-[0.3em] mb-2">
          <UserPlus size={14} /> <span className="blink-cursor">crear_cuenta</span>
        </div>
        <h1 className="text-3xl text-neutral-100 uppercase tracking-tighter font-bold mb-8">
          Registrar<br/><span className="text-red-500">nuevo operador</span>
        </h1>

        <label className="term-label">Nombre</label>
        <input data-testid="register-name-input" required value={name} onChange={(e) => setName(e.target.value)}
          className="term-input mb-4" placeholder="Tu nombre" />

        <label className="term-label">Email (dominio de tu empresa)</label>
        <input data-testid="register-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className="term-input mb-1" placeholder="tu@empresa.com" />
        <div className="text-[0.65rem] uppercase tracking-[0.2em] text-neutral-500 mb-4">
          El dominio debe estar autorizado por el administrador
        </div>

        <label className="term-label">Contraseña (mín 6)</label>
        <input data-testid="register-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          className="term-input mb-6" placeholder="********" />

        {error && (
          <div data-testid="register-error" className="flex items-start gap-2 text-red-500 text-xs uppercase tracking-widest mb-4 shake">
            <AlertOctagon size={14} className="mt-0.5" />
            <span className="glitch">{error}</span>
          </div>
        )}

        <button data-testid="register-submit-btn" type="submit" disabled={busy} className="term-btn w-full justify-center">
          {busy ? "> creando..." : "> Crear cuenta"}
        </button>

        <div className="mt-6 text-xs text-neutral-500 uppercase tracking-[0.2em]">
          ¿Ya tienes cuenta? <Link data-testid="register-goto-login" to="/login" className="text-red-500">Ingresar</Link>
        </div>
      </form>
    </div>
  );
}
